import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAspectRatio34: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="aspect-ratio-3-4, portrait"><path d="M5.75 2C4.7835 2 4 2.7835 4 3.75V20.25C4 21.2165 4.7835 22 5.75 22H18.25C19.2165 22 20 21.2165 20 20.25V3.75C20 2.7835 19.2165 2 18.25 2H5.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconAspectRatio34;
